/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);
export function slider() {

    const projectsCardsSliderSelector = ".content-box-items.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Projects sliders
        const projectsSliders = [];
        const projectsSliderElements = document.querySelectorAll(projectsCardsSliderSelector);
        if (projectsSliderElements) {
            projectsSliderElements.forEach(slider => {

                projectsSliders.push(new Swiper(slider, {
                    direction: 'horizontal',
                    slidesPerView: '1',
                    centeredSlides: true,
                    spaceBetween: 20,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",           
                    },

                    breakpoints: {
                        768: {
                          slidesPerView: '2',
                          spaceBetween: 30,
                          watchOverflow: true,
                          centeredSlides: false
                        },
                    },

                    breakpoints: {
                        820: {
                          slidesPerView: 'auto',
                          spaceBetween: 0,
                          watchOverflow: true,
                          centeredSlides: false
                        },
                    },

                    breakpoints: {
                        1200: {
                          slidesPerView: 'auto',
                          spaceBetween: 0,
                          watchOverflow: true,
                          centeredSlides: false
                        },
                    },
                   
                    pagination: {
                        el: ".swiper-pagination",
                        type: 'bullets',
                        clickable: true
                    },
                    on: {
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    };

    init();
}
